import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { ApplicationLanguages } from "../components/language/language";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
    constructor(private authservice:AuthService,private http:HttpClient){}

    /** French portal / self-guided hosts default UI to French when no language is saved yet. */
    applyHostDefaultLanguageIfNeeded(): void {
        if (localStorage.getItem('language')) {
            return;
        }
        if (this.isFrenchHost()) {
            this.setCurrentLang(ApplicationLanguages.FRENCH.toString());
        }
    }

    isFrenchHost(): boolean {
        const host = window.location.hostname.toLowerCase();
        return host === 'autonome.localhost'
            || host.endsWith('.rse.acsm.ca')
            || host === 'rse.acsm.ca'
            || host.startsWith('autonome.');
    }

    setCurrentLang(lang:string)
    {
        localStorage.setItem('language', lang);
    }

    getCurretnLang():ApplicationLanguages
    {
        let currentlang = this.authservice.getUserLoginData().participantLastActiveLanguage
        return (currentlang == null || Number.isNaN(currentlang))? ApplicationLanguages.ENGLISH:currentlang
    }

    getCurrentActiveLanguageName()
    {
        let currentlang = this.authservice.getUserLoginData().participantLastActiveLanguage
        switch(currentlang)
        {
            case ApplicationLanguages.ENGLISH:
                return 'English'
                break;
            case ApplicationLanguages.FRENCH:
                return 'Français'
                break;
            default:
                return 'English'
                break;

        }
    }

   getApplicationLanguages():Observable<any[]>
   {
    const token = this.authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<any[]>(this.apiUrl+'language/getApplicationLanguages',{headers:headers})
   }
}
